import {createContext} from "react";

let _display: boolean = false;
let _shipping: boolean = false;
export const PopupContext = createContext({
    display: _display,
    shipping: _shipping,
    setDisplay: (d: boolean, shipping: boolean) => { _display = d; _shipping = shipping }
});
